import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { AppointmentControllerApi } from "../../services";
import {
  getConfigObject,
  getXtenantId,
  useBaseContent,
} from "../../utils/utils";

interface UseVisitHistoryProps {
  patientUuid: string;
  page?: number;
  size?: number;
  sortBy?: string;
  sortDirection?: "asc" | "desc";
  appointmentStatus?: string;
  appointmentMode?: string;
  providerUuid?: string[];
  startDate?: string;
  endDate?: string;
  searchString?: string;
  disabled?: boolean;
}

export function useVisitHistory(
  props: UseVisitHistoryProps
): useBaseContent<any> {
  const {
    patientUuid,
    page = 0,
    size = 20,
    sortBy = "start_time",
    sortDirection = "desc",
    appointmentStatus,
    appointmentMode,
    providerUuid,
    startDate,
    endDate,
    searchString,
    disabled,
  } = props;

  return useQuery({
    queryKey: [
      "visit-history",
      patientUuid,
      page,
      size,
      sortBy,
      sortDirection,
      appointmentStatus,
      appointmentMode,
      providerUuid,
      startDate,
      endDate,
      searchString,
    ],
    enabled: !!patientUuid && !disabled,
    placeholderData: keepPreviousData,
    refetchOnWindowFocus: false,
    queryFn: async () => {
      return new AppointmentControllerApi(getConfigObject())
        .getVisitHistory(
          page,
          size,
          sortBy,
          sortDirection,
          patientUuid,
          providerUuid,
          undefined, // locationUuid
          undefined, // filter
          undefined, // appointmentType
          appointmentMode,
          appointmentStatus,
          undefined, // appStatusForPatient
          startDate,
          endDate,
          undefined, // archive
          undefined, // notForBilling
          undefined, // superBillGenerated
          searchString,
          getXtenantId()
        )
        .then((it) => it?.data);
    },
  });
}
